import UpdateArrow from './UpdateArrow';
import { UpdateArrowProps, UpdateArrowValueProps } from './types';

export type { UpdateArrowProps, UpdateArrowValueProps };
export default UpdateArrow;
